import { injectable } from "inversify";

/**
 * Base service class. Merely a placeholder for now.
 * But could be home to some common methods or properties in the future.
 */
@injectable()
export abstract class ServiceBase {

}
